import axios from "./axiosInstance";
import {
  TodayCashboxApiResponse,
  TodayCashboxPayload,
  TodayCashboxSearchParams,
  CashTransactionsApiResponse
} from "../types/cashTransactionTypes";

export const getTodayCashbox = async (
  params: TodayCashboxSearchParams = {}
): Promise<TodayCashboxApiResponse> => {
  const response = await axios.get<TodayCashboxApiResponse>("/cash-transactions/today", {
    params: {
      ...params,
      page: params.page ?? 1,
      limit: params.limit ?? 50,
    },
  });
  return response.data;
};


export const getAllTransactions = async (
  params: TodayCashboxSearchParams = {}
): Promise<CashTransactionsApiResponse> => {
  const response = await axios.get<CashTransactionsApiResponse>("/cash-transactions", {
    params: {
      ...params,
      page: params.page ?? 1,
      limit: params.limit ?? 50,
    },
  });
  return response.data;
};
